import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ALL_FILTER,
  CONFERENCE_ARTICLE,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_LIST,
  CONFERENCE_ARTICLE_PROOF,
  CONFERENCE_ARTICLE_STEP,
  CONFERENCE_CATEGORY_ALL,
  CONFERENCE_CREATE,
  CONFERENCE_MAGAZINE_ARTICLE,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const CONFERENCES = GLOBAL_STATE

export const { reducer: conferenceReducer } = createSlice({
  name: CONFERENCES,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.conference.pending, state => {
        state[CONFERENCE].loading = true
      })
      .addCase(actionCreators.conference.rejected, (state, action) => {
        state[CONFERENCE].loading = false
        state[CONFERENCE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conference.fulfilled, (state, action) => {
        state[CONFERENCE].loading = false
        state[CONFERENCE].error = null
        state[CONFERENCE].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceCreate.pending, state => {
        state[CONFERENCE_CREATE].loading = true
      })
      .addCase(actionCreators.conferenceCreate.rejected, (state, action) => {
        state[CONFERENCE_CREATE].loading = false
        state[CONFERENCE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceCreate.fulfilled, (state, action) => {
        state[CONFERENCE_CREATE].loading = false
        state[CONFERENCE_CREATE].error = null
        state[CONFERENCE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceAll.pending, state => {
        state[CONFERENCE_ALL].loading = true
      })
      .addCase(actionCreators.conferenceAll.rejected, (state, action) => {
        state[CONFERENCE_ALL].loading = false
        state[CONFERENCE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceAll.fulfilled, (state, action) => {
        state[CONFERENCE_ALL].loading = false
        state[CONFERENCE_ALL].error = null
        state[CONFERENCE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceAllFilter.pending, state => {
        state[CONFERENCE_ALL_FILTER].loading = true
      })
      .addCase(actionCreators.conferenceAllFilter.rejected, (state, action) => {
        state[CONFERENCE_ALL_FILTER].loading = false
        state[CONFERENCE_ALL_FILTER].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceAllFilter.fulfilled, (state, action) => {
        state[CONFERENCE_ALL_FILTER].loading = false
        state[CONFERENCE_ALL_FILTER].error = null
        state[CONFERENCE_ALL_FILTER].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticle.pending, state => {
        state[CONFERENCE_ARTICLE].loading = true
      })
      .addCase(actionCreators.conferenceArticle.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE].loading = false
        state[CONFERENCE_ARTICLE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticle.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE].loading = false
        state[CONFERENCE_ARTICLE].error = null
        state[CONFERENCE_ARTICLE].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticleList.pending, state => {
        state[CONFERENCE_ARTICLE_LIST].loading = true
      })
      .addCase(actionCreators.conferenceArticleList.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_LIST].loading = false
        state[CONFERENCE_ARTICLE_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticleList.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_LIST].loading = false
        state[CONFERENCE_ARTICLE_LIST].error = null
        state[CONFERENCE_ARTICLE_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticleAll.pending, state => {
        state[CONFERENCE_ARTICLE_ALL].loading = true
      })
      .addCase(actionCreators.conferenceArticleAll.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_ALL].loading = false
        state[CONFERENCE_ARTICLE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticleAll.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_ALL].loading = false
        state[CONFERENCE_ARTICLE_ALL].error = null
        state[CONFERENCE_ARTICLE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceMagazineArticle.pending, state => {
        state[CONFERENCE_MAGAZINE_ARTICLE].loading = true
      })
      .addCase(actionCreators.conferenceMagazineArticle.rejected, (state, action) => {
        state[CONFERENCE_MAGAZINE_ARTICLE].loading = false
        state[CONFERENCE_MAGAZINE_ARTICLE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceMagazineArticle.fulfilled, (state, action) => {
        state[CONFERENCE_MAGAZINE_ARTICLE].loading = false
        state[CONFERENCE_MAGAZINE_ARTICLE].error = null
        state[CONFERENCE_MAGAZINE_ARTICLE].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticleStep.pending, state => {
        state[CONFERENCE_ARTICLE_STEP].loading = true
      })
      .addCase(actionCreators.conferenceArticleStep.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_STEP].loading = false
        state[CONFERENCE_ARTICLE_STEP].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticleStep.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_STEP].loading = false
        state[CONFERENCE_ARTICLE_STEP].error = null
        state[CONFERENCE_ARTICLE_STEP].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticleProof.pending, state => {
        state[CONFERENCE_ARTICLE_PROOF].loading = true
      })
      .addCase(actionCreators.conferenceArticleProof.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_PROOF].loading = false
        state[CONFERENCE_ARTICLE_PROOF].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticleProof.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_PROOF].loading = false
        state[CONFERENCE_ARTICLE_PROOF].error = null
        state[CONFERENCE_ARTICLE_PROOF].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceCategoryAll.pending, state => {
        state[CONFERENCE_CATEGORY_ALL].loading = true
      })
      .addCase(actionCreators.conferenceCategoryAll.rejected, (state, action) => {
        state[CONFERENCE_CATEGORY_ALL].loading = false
        state[CONFERENCE_CATEGORY_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceCategoryAll.fulfilled, (state, action) => {
        state[CONFERENCE_CATEGORY_ALL].loading = false
        state[CONFERENCE_CATEGORY_ALL].error = null
        state[CONFERENCE_CATEGORY_ALL].data = action.payload
      })

    builder.addCase(actionCreators.conferenceClear, state => {
      state[CONFERENCE] = defaultState()
    })

    builder.addCase(actionCreators.conferenceArticleClear, state => {
      state[CONFERENCE_ARTICLE] = defaultState()
    })

    builder.addCase(actionCreators.conferenceArticleListClear, state => {
      state[CONFERENCE_ARTICLE_LIST] = defaultState()
    })

    builder.addCase(actionCreators.conferenceArticleAllClear, state => {
      state[CONFERENCE_ARTICLE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.conferenceMagazineArticleClear, state => {
      state[CONFERENCE_MAGAZINE_ARTICLE] = defaultState()
    })

    builder.addCase(actionCreators.conferenceAllClear, state => {
      state[CONFERENCE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.conferenceAllFilterClear, state => {
      state[CONFERENCE_ALL_FILTER] = defaultState()
    })

    builder.addCase(actionCreators.conferenceCategoryAllClear, state => {
      state[CONFERENCE_CATEGORY_ALL] = defaultState()
    })
  },
})
